<template>
  <div>
    <div style=" font-size: 18px;margin-top: -27px;padding-bottom: 20px;    text-align: center;">角色选择</div>
    <!--    <a-tree-->
    <!--      :data="roleData"-->
    <!--      show-checkbox-->
    <!--      default-expand-all-->
    <!--      node-key="id"-->
    <!--      ref="tree"-->
    <!--      :default-checked-keys="treeData"-->
    <!--      @check-change="handleSelectionChange"-->
    <!--      :props="defaultProps">-->
    <!--    </a-tree>-->
    <a-tree :tree-data="treeData"
            checkable
            v-model="checkedKeys"

    >
      <template slot="title" slot-scope="{ title }">
<!--            <span v-if="title.indexOf(searchValue) > -1">-->
<!--              {{ title.substr(0, title.indexOf(searchValue)) }}-->
<!--              <span style="color: #f50">{{ searchValue }}</span>-->
<!--              {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}-->
<!--            </span>-->
<!--        <span v-else>{{ title }}</span>-->
        <span>{{ title }}</span>
      </template>
    </a-tree>
    <!--    <div slot="footer" class="dialog-footer" style="text-align: center;">-->
    <!--      <a-button type="primary" @click="cancel"-->
    <!--                 class="project-dialog-button">取消-->
    <!--      </a-button>-->
    <!--      <a-button type="primary" @click="save"-->
    <!--                 class="project-dialog-button">保存-->
    <!--      </a-button>-->
    <!--    </div>-->
  </div>

</template>

<script>
import {findUserRole, saveUserRole} from '../../../api/user';
import {getRoleList} from '../../../api/role';

async function getUserRole() {
  // this.roleData = [];
  this.treeData[0].children = []
  const result = await getRoleList();
  if (result.code === 1200) {
    // this.roleData = result.data.roles;
    let roles = result.data.roles;
    let length = roles.length;
    for (let i = 0; i < length; i++) {
      this.treeData[0].children.push({
        title: roles[i].name,
        key: roles[i].id
      })
    }
    const res = await findUserRole(this.form.data.id);
    if (res.code === 1200){
      let length = res.data.userRoles.length;
      for (let i = 0; i < length; i ++){
        this.checkedKeys.push(res.data.userRoles[i].id)
      }
    }
  }
}

async function save() {
  const res = await saveUserRole(this.form.data.id, this.checkedKeys.toString());
  if (res.code === 1200) {
    this.$message.success('角色更新成功')
  } else {
    this.$message.error('角色更新失败')
  }
  this.form.data = {};
}

function cancel() {
  this.form.data = {};
  // if (this.onCancelHandler) {
  //   this.onCancelHandler();
  // }
}

function handleSelectionChange() {
  const res = this.$refs.tree.getCheckedNodes();
  this.roleIds = '';
  res.forEach((item) => {
    this.roleIds = `${ this.roleIds + item.id },`;
  });
}

export default {
  name: 'UserRole',
  props: {
    userId: String,
    onSaveHandler: Function,
    onCancelHandler: Function,
  },
  data() {
    return {
      checkedKeys: [],
      treeData: [{
        title: '公司名',
        key: 'company',
        children: []
      }],
      // treeData: [],
      // roleData: [],
      // roleIds: '',
      // defaultProps: {
      //   children: 'children',
      //   label: 'name',
      // },
      form: {
        data: {
          id: '',
          name: '',
        },
      },
      formRules: {},
    };
  },
  watch: {
    userId(val) {
      this.form.data.id = val;
      this.getUserRole();
    },
  },
  created() {
    this.form.data.id = this.userId;
    this.getUserRole();
  },
  methods: {
    save,
    cancel,
    getUserRole,
    handleSelectionChange,
  },
};
</script>

<style scoped>

</style>
